<template>
  <div style="background:#fff;">
    <div class="header content-continer">
      <p class="logo left"><router-link to="/home"><img src="../assets/logo.png"></router-link></p>
      <!-- <p class="right icon-btn" @click="returns"><img src="../assets/hospital-img/return.png">退出</p> -->
      <p class="right icon-btn">
        <el-dropdown trigger="click">
          <p class="head-nav-wrap">
            <span class="header-nav-name">{{orgName?orgName:'管理员'}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </p>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link to="/CIndex/company-means">公司信息</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/CIndex/company-user">权限分配</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-popover
                placement="right"
                trigger="hover"
                width="100"
              >
                <span slot="reference">角色切换</span>
                <slot name="content">
                  <p class="header-role" @click="switchRole(2)">机构账号</p>
                  <p class="header-role" @click="switchRole(3)">个人账号</p>
                </slot>

                <!-- 1公司 2机构（医院）  3个人(crc)-->
              </el-popover>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click="returns">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </p> 

      <ul>
        <li>
          <router-link to="/CIndex/company-home">项目管理</router-link>
        </li>
        <li>
          <router-link to="/CIndex/company-person">人员管理</router-link>
        </li>
        <li>
          <router-link to="/CIndex/company-statistics">委派统计</router-link>
        </li>
      </ul>

    </div> 
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import { switchRole } from "@/request/api";

  export default {
    name: "Header",
    data() {
      return {
        msg: "Welcome to Your Vue.js App",
        href: this.Common.href,
        orgName: '',
      };
    },
    methods: {

      returns() {
        let token = Cookies.get('token');
        console.log(token);
        Cookies.remove('token');
        Cookies.remove('userid');
        Cookies.remove('unionId');
        Cookies.remove('orgName');
        console.log(Cookies.get('token'));
        this.$router.push("/login-company");
         window.location.href =
        'https://www.gcphr.cn'
      },

      logining(param) {
     
        Cookies.set("token", param.token);
        Cookies.set("userid", param.userId);
        Cookies.set("accountType", param.accountType);
        Cookies.set("orgName", param.orgName);

        this.$message({
          message: "账号切换成功",
          type: "success"
        });

        // 进入首页
        if(param.accountType == 1){
          this.$router.replace("/CIndex/company-home");
        }else if(param.accountType == 2){
          this.$router.replace("/HIndex/hostipal-home");
        }else if(param.accountType == 3){
          this.$router.push('/person-home')
        }
      },

      // 切换登陆的角色类型
      switchRole:async function(param){
        try{
          let responseData = await switchRole(param);
          if(responseData.data.code == '00000'){
            // 清除-退出
            Cookies.remove("token");
            Cookies.remove("userid");
            Cookies.remove("unionId");
            Cookies.remove("orgName");
            // 再次登陆
            this.logining(responseData.data.data);
          }else{
            this.$message.error(responseData.data.message);
          }
        }catch(error){
          console.log(error);
        }
      },
    },

    mounted:function(){
      this.orgName = Cookies.get('orgName');
    }
  };
</script>
<style scoped>
  .header {
    height: 70px;
    line-height: 70px;
  }

  .header ul {
    float: right;
    list-style-type: none;
    margin-right: 100px;
  }

  .header ul li {
    display: inline-block;
    width: 130px;
    height: 40px;
    text-align: center;
  }

  .active {
    background: #4A88D3;
    border-radius: 4px;
    color: #fff !important;
    line-height: 40px;
  }

  .header a {
    color: #333;
    font-size: 16px;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;

  }

  .logo img {
    vertical-align: middle;
  }

  .logo-name {
    font-size: 20px;
    font-family: SourceHanSansCN-Regular;
    font-weight: bold;
    color: rgba(55, 113, 202, 1);
    margin-left: 12px;
  }

  .icon-btn {
    margin-left: 30px;
    cursor: pointer;
  }

  .icon-btn img {
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 6px;
  }

  .el-dropdown-menu__item a {
    display: block;
    color: #4c4c4c
  }

  .el-dropdown-menu__item {
    width: 120px;
    text-align: center;
    height: 40px;

    padding: 0px;
  }

  .el-dropdown-menu {
    padding: 0px;
  }
  .header-nav-name {
    width: 150px;
    /* border: 1px solid red; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    /* margin-right: 30px; */
  }
  .head-nav-wrap {
    height: 70px;
    line-height: 70px;
  }
  .el-icon-arrow-down {
    position: relative;
    top: -30px;
  }
  .header-role {
    padding: 10px 0px;
    text-align: center;
  }
  .header-role:hover {
    color: red;
    cursor: pointer;
    background-color: #f5f5f5;
  } 
</style>


// WEBPACK FOOTER //
// src/company/header.vue